/**
 * Webcam for business
 */
export class Webcam {
  /**
   * Unique identifier for this record in the database
   */
  webcamId: number;

  /**
   * The name of the webcam
   */
  name: string;

  /**
   * The location/site of the webcam
   */
  site: string;

  /**
   * The URL of the webcam
   */
  url: string;

  /**
   * The direction the webcam is facing
   */
  direction: string;

  /**
   * The operator of the webcam
   */
  operatedBy: string;

  /**
   * Parses webcam data
   * @param data {any} Webcam data as returned by API
   * @return {Webcam} Parsed webcam data
   */
  static parse(data: any): Webcam {
    return {
      webcamId: data.webcamId,
      name: data.name || null,
      site: data.site || null,
      url: data.url || null,
      direction: data.direction || null,
      operatedBy: data.operatedBy || null
    };
  }
}
